import React from 'react'

export default function Software() {
  return (
    <div>Software</div>
  )
}
